import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { submitForm } from '../utils/submitForm';
import { trackEvent } from '../utils/analytics';
import { company, institutionTypes } from '../data/site';

const emptyForm = {
  name: '',
  institute: '',
  type: '',
  city: '',
  phone: '',
  email: '',
  website: '',
  social: '',
  goals: ''
};

const AuditForm = () => {
  const [formData, setFormData] = useState(emptyForm);
  const [status, setStatus] = useState('idle');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    try {
      const result = await submitForm(`Free audit request: ${formData.institute}`, formData, 'audit');
      if (result === 'sent') trackEvent('generate_lead', { form_name: 'audit', institution_type: formData.type });
      setStatus(result);
      setFormData(emptyForm);
    } catch (error) {
      setStatus('error');
    }
  };

  if (status === 'sent' || status === 'mailto') {
    return (
      <div className="contact-form audit-done" role="status">
        <h3>Request received</h3>
        <p>
          {status === 'sent'
            ? 'Thank you! Our team will review your institute’s online presence and contact you with your audit.'
            : 'Your email app has opened with your request. Just hit send and we’ll get started.'}
        </p>
        <button type="button" className="btn btn-secondary" onClick={() => setStatus('idle')}>
          Request another audit
        </button>
      </div>
    );
  }

  return (
    <form className="contact-form" onSubmit={handleSubmit} id="audit-form">
      <h3>Request your free audit</h3>
      <p>Takes under a minute. No cost, no obligation.</p>

      <div className="form-row">
        <div className="form-group">
          <label htmlFor="audit-name">Your name</label>
          <input id="audit-name" name="name" autoComplete="name" value={formData.name} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <label htmlFor="audit-institute">Institute name</label>
          <input id="audit-institute" name="institute" autoComplete="organization" value={formData.institute} onChange={handleChange} required />
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label htmlFor="audit-type">Type of institute</label>
          <select id="audit-type" name="type" value={formData.type} onChange={handleChange} required>
            <option value="" disabled>Select one</option>
            {institutionTypes.map((type) => (
              <option key={type} value={type}>{type}</option>
            ))}
            <option value="Other">Other</option>
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="audit-city">City</label>
          <input id="audit-city" name="city" autoComplete="address-level2" value={formData.city} onChange={handleChange} required />
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label htmlFor="audit-phone">Phone / WhatsApp</label>
          <input id="audit-phone" name="phone" type="tel" autoComplete="tel" pattern="[0-9+\-\s]{10,15}" title="Enter a 10-digit mobile number" value={formData.phone} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <label htmlFor="audit-email">Email</label>
          <input id="audit-email" name="email" type="email" autoComplete="email" value={formData.email} onChange={handleChange} required />
        </div>
      </div>

      <div className="form-group">
        <label htmlFor="audit-website">Website <span className="optional">(if you have one)</span></label>
        <input id="audit-website" name="website" type="text" inputMode="url" placeholder="e.g. yourschool.in" value={formData.website} onChange={handleChange} />
      </div>

      <div className="form-group">
        <label htmlFor="audit-social">Instagram, Facebook or Google listing <span className="optional">(optional)</span></label>
        <input id="audit-social" name="social" type="text" placeholder="Links or page names" value={formData.social} onChange={handleChange} />
      </div>

      <div className="form-group">
        <label htmlFor="audit-goals">What would you most like to improve? <span className="optional">(optional)</span></label>
        <textarea id="audit-goals" name="goals" placeholder="e.g. more admission enquiries, better Google reviews, a new website" value={formData.goals} onChange={handleChange}></textarea>
      </div>

      <button type="submit" className="btn btn-lg" disabled={status === 'sending'}>
        {status === 'sending' ? 'Sending...' : 'Get my free audit'}
      </button>
      <p className="form-note">
        By submitting you agree to our <Link to="/privacy">privacy policy</Link>.
      </p>

      {status === 'error' && (
        <p className="form-status error" role="alert">
          Something went wrong. Please email us at {company.email} or message us on WhatsApp.
        </p>
      )}
    </form>
  );
};

export default AuditForm;
